export const API_BASE = process.env.REACT_APP_API_URL || 'http://localhost:5001/api';

let tokenProvider = null;

export function configureApiAuth(getToken) {
  tokenProvider = getToken;
}

export function getProjectId() {
  const storageKey = 'dam-migration-project-id';
  return window.localStorage.getItem(storageKey);
}

export function setProjectId(projectId) {
  const storageKey = 'dam-migration-project-id';
  if (projectId) {
    window.localStorage.setItem(storageKey, projectId);
  } else {
    window.localStorage.removeItem(storageKey);
  }
}

export function apiUrl(path) {
  if (/^https?:\/\//.test(path)) return path;
  return `${API_BASE}${path.startsWith('/') ? path : `/${path}`}`;
}

export async function apiFetch(path, options = {}) {
  const headers = new Headers(options.headers || {});
  const projectId = getProjectId();
  if (projectId) headers.set('X-Project-ID', projectId);
  if (tokenProvider) {
    const token = await tokenProvider();
    if (token) headers.set('Authorization', `Bearer ${token}`);
  }
  return window.fetch(apiUrl(path), { ...options, headers });
}

export async function downloadApiFile(path, fallbackName) {
  const response = await apiFetch(path);
  if (!response.ok) {
    let message = `Download failed (${response.status})`;
    try {
      const data = await response.json();
      message = data.message || data.error || message;
    } catch (_) {
      // Keep the HTTP status message.
    }
    throw new Error(message);
  }
  const blob = await response.blob();
  const disposition = response.headers.get('content-disposition') || '';
  const match = disposition.match(/filename\*?=(?:UTF-8''|"?)([^";]+)/i);
  const filename = match ? decodeURIComponent(match[1].replace(/"/g, '')) : fallbackName;
  const href = window.URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = href;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  link.remove();
  window.URL.revokeObjectURL(href);
}
